import { Columns } from '@shared/interfaces/table/column-config';
import { MeteringPointDetails } from '@app/api/dmc';
import { settlementmethodPartial } from '@shared/partials/settlementmethod.partial';
import { meterReadingOccurrencePartial } from '@shared/columns/meteringpoint.columns';

export const  meteringpointDetailsMasterdata: Columns<MeteringPointDetails>[] = [
  {
    ...settlementmethodPartial as Columns<MeteringPointDetails>,
    key: 'detailCharacteristics.settlementMethod'
  },
  {
    ...meterReadingOccurrencePartial as Columns<MeteringPointDetails>,
    key: 'detailCharacteristics.meterReadingOccurrence'
  },
  {
    title: 'Estimeringsgruppe',
    key: 'estimationGroup'
  },
];
